//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"ActiveAxis",1,0],[0,"ActivePlane",1,0],[0,"DisplayAxisBlock",1,0],[0,"DisplayPlaneBlock",1,0],[0,"DisplayReferenceBlock",1,0],[0,"DisplayXaxis",1,0],[0,"DisplayXyplane",1,0],[0,"DisplayXzplane",1,0],[0,"DisplayYaxis",1,0],[0,"DisplayYzplane",1,0],[0,"DisplayZaxis",1,0],[1,"SelectFixedCsys",0,"SelectNXObject",0],[1,"SelectProgramCsys",0,"SelectNXObject",0],[0,"Type",1,0]],[],[]];
SPLM.GeometricUtilities.OrientXpressTestBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.OrientXpressTestBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.OrientXpressTestBuilder.Types = Object.freeze({
    "OrientXpress" : "OrientXpress", "OrientXpressFixed" : "OrientXpressFixed", "OrientXpressProgramDefined" : "OrientXpressProgramDefined"});

SPLM.GeometricUtilities.OrientXpressTestBuilder.Axis = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "None" : "None"});

SPLM.GeometricUtilities.OrientXpressTestBuilder.Plane = Object.freeze({
    "Xy" : "Xy", "Yz" : "Yz", "Xz" : "Xz", "None" : "None"});

SPLM.GeometricUtilities.OrientXpressTestBuilder.AxisBlock = Object.freeze({
    "Show" : "Show", "Hide" : "Hide"});

SPLM.GeometricUtilities.OrientXpressTestBuilder.PlaneBlock = Object.freeze({
    "Show" : "Show", "Hide" : "Hide"});

SPLM.GeometricUtilities.OrientXpressTestBuilder.ReferenceBlock = Object.freeze({
    "Show" : "Show", "Hide" : "Hide"});

export default SPLM;